module.exports = "/_next/static/images/bead-header-9d51b2c9aefa12651284ef2ee3ba1825.webp";